import { useEffect, useState } from 'react';

import {
    differenceInDays,
    differenceInHours,
    differenceInMinutes,
    differenceInMonths,
    differenceInSeconds,
    differenceInWeeks,
    differenceInYears
} from 'date-fns';

import './Countdown.css';

export function CountDown({ weddingDate, dayStart, dayEnd, i18n, FX }) {
    const { today, countDownLabels, plural } = i18n;
    const [now, setNow] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => setNow(new Date()), 1000);
        return () => window.clearInterval(interval);
    }, []);

    const getData = () => {
        const nowCopy = new Date(now); // avoid mutating state
        let wedding = new Date(weddingDate);

        const years = differenceInYears(wedding, nowCopy);
        nowCopy.setFullYear(nowCopy.getFullYear() + years);

        const months = differenceInMonths(wedding, nowCopy);
        nowCopy.setMonth(nowCopy.getMonth() + months);

        const weeks = differenceInWeeks(wedding, nowCopy);
        nowCopy.setDate(nowCopy.getDate() + weeks * 7);

        const days = differenceInDays(wedding, nowCopy);
        nowCopy.setDate(nowCopy.getDate() + days);

        const hours = differenceInHours(wedding, nowCopy);
        nowCopy.setHours(nowCopy.getHours() + hours);

        const minutes = differenceInMinutes(wedding, nowCopy);
        nowCopy.setMinutes(nowCopy.getMinutes() + minutes);

        const seconds = differenceInSeconds(wedding, nowCopy);

        return {
            seconds,
            minutes,
            hours,
            days,
            weeks,
            months,
            years
        };
    }

    const { years, months, weeks, days, hours, minutes, seconds } = getData();
    const labels = [
        { [plural(countDownLabels.years, years)]: Math.abs(years) },
        { [plural(countDownLabels.months, months)]: Math.abs(months) },
        { [plural(countDownLabels.weeks, weeks)]: Math.abs(weeks) },
        { [plural(countDownLabels.days, days)]: Math.abs(days) },
        { [plural(countDownLabels.hours, hours)]: Math.abs(hours) },
        { [plural(countDownLabels.minutes, minutes)]: Math.abs(minutes) },
        { [plural(countDownLabels.seconds, seconds)]: Math.abs(seconds) }
    ];

    const weddingDayStart = new Date(dayStart).getTime();
    const weddingDayEnd = new Date(dayEnd).getTime();

    const isToday = now.getTime() > weddingDayStart && now.getTime() < weddingDayEnd;

    return (
        <>
            <div className="countdown-module container">
                <div className="cntdwn">
                    {
                        isToday
                            ? <>
                                <span className="today">{today}</span>
                                {FX}
                            </>
                            : <>

                                {labels
                                    .slice(0, labels.length)
                                    .map((label, key) => {
                                        return <span className="entry" key={key}>
                                            <span className="number">{Object.entries(label)[0][1]}</span>
                                            <span className="text">{Object.entries(label)[0][0]}</span>
                                        </span>
                                    })
                                }
                            </>
                    }
                </div>
            </div>
        </>
    );
}
